var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "workflow-form" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "input title-input" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("Title")]),
          _vm._v(" "),
          _c("a-input", {
            staticClass: "classic-new-input",
            attrs: { placeholder: "Task #" },
            model: {
              value: _vm.form.title,
              callback: function ($$v) {
                _vm.$set(_vm.form, "title", $$v)
              },
              expression: "form.title",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "input title-input" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("Description")]),
          _vm._v(" "),
          _c("quill-editor", {
            staticClass: "quill-editor",
            attrs: {
              options: _vm.editorOption,
              placeholder: "Workflow Description",
            },
            model: {
              value: _vm.form.description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "description", $$v)
              },
              expression: "form.description",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "input title-input" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("Stages and statuses")]),
          _vm._v(" "),
          _c(
            "draggable",
            {
              attrs: {
                options: _vm.dragOptions,
                draggable: ".drag-row",
                group: { name: "pipeline", pull: "clone", put: false },
              },
              model: {
                value: _vm.form.pipelines,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "pipelines", $$v)
                },
                expression: "form.pipelines",
              },
            },
            [
              _c(
                "transition-group",
                { staticClass: "drag-rows" },
                _vm._l(_vm.form.pipelines, function (pipeline, index) {
                  return _c(
                    "div",
                    {
                      key: "p_" + index,
                      staticClass: "drag-row",
                      style: { "--row-color": "" + pipeline.color },
                      on: {
                        dblclick: function ($event) {
                          return _vm.editStage(pipeline)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "pipeline-content" }, [
                        _c("div", { staticClass: "pipeline-picker" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: pipeline.color,
                                expression: "pipeline.color",
                              },
                            ],
                            staticStyle: { opacity: "0" },
                            attrs: { type: "color" },
                            domProps: { value: pipeline.color },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(pipeline, "color", $event.target.value)
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "pipeline-name",
                            attrs: { contenteditable: "true" },
                            on: {
                              input: function (e) {
                                return (pipeline.name =
                                  e.$refs.target.innerText)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(pipeline.name) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "last-action" }, [
                        _c("div", { staticClass: "pipeline-type" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.formatType(pipeline.type)) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pipeline-actions" }, [
                          _c(
                            "div",
                            {
                              staticClass: "material-icons edit",
                              on: {
                                click: function ($event) {
                                  return _vm.editStage(pipeline)
                                },
                              },
                            },
                            [_vm._v("edit")]
                          ),
                          _vm._v(" "),
                          pipeline.isDeleted
                            ? _c(
                                "div",
                                {
                                  staticClass: "material-icons delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteStage(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    delete\n                                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              staticStyle: { "margin-top": "10px" },
              on: { click: _vm.createStage },
            },
            [_vm._v("Create Stage")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }